module.exports = __webpack_public_path__ + "static/media/3c_website_logo_coorg_aee.36cca25d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3c_website_logo_coorg_aee.jpg
// module id = 43
// module chunks = 0